import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import { protexiMeta } from "../data/DataMetatags";
import { defBreadcrumb } from "../data/DataBreadcrumb";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { ProtexiBreadcrumb } from "../data/DataBreadcrumb";
import ProtexiImg from "../../public/static/images/svg/Protexi-1SVG.svg";
import Benefit from "../../public/static/images/svg/cacat-total-ccSVG.svg";
import RawatInap from "../../public/static/images/svg/rawat-inap-ccSVG.svg";
import downloadIcon from "../../public/static/images/svg/download-icon.svg";
import { ImageComponent } from "../components/UserInterface/ImageComponent";
import Description from "../components/UserInterface/Description";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import { StepsComponent } from "../components/UserInterface/StepsComponent";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import { DownloadLink } from "../components/UserInterface/DownloadLink";
import { SEOText } from "../components/UserInterface/SEOText";
import { ProtexiSEO } from "../data/DataSEO";

const Protexi = (props) => {
  const {
    breadcrumb,
    title,
    description,
    path,
    ProtexiBreadcrumb,
    ProtexiSEO
  } = props;

  return (
    <Layout>
      <NextHead
        description={description}
        title={title}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={ProtexiBreadcrumb} />
      <ImageComponent url={ProtexiImg} />
      <LayoutCenter margin="0 16px 24px 16px" widthLayout="1000px">
        <Description
          alignMobile="left"
          fontSize="16px"
          font="Roboto"
          marginMobile="0 8px"
          text="Gunakan Home Credit Card dan Home Credit BayarNanti kamu dengan nyaman bersama PROTEXI!<br/><br/>PROTEXI adalah Produk Perlindungan atas pembayaran cicilan Home Credit Card dan Home Credit BayarNanti dari risiko tak terduga. PROTEXI memberi keringanan sehingga kamu dan keluarga tidak lagi terbebani."
        />
      </LayoutCenter>
      <StepsComponent
        maxWidth="440px"
        marginWeb="64px 0"
        marginMobile="48px 0 0 0"
        img={Benefit}
        title="Risiko Meninggal Dunia dan Cacat Tetap Total Karena sakit atau kecelakaan dalam Masa Asuransi"
        subtitle={`Penggantian sebesar Jumlah yang Terhutang pada Home Credit Card dan/atau Home Credit BayarNanti yang akan dibayarkan oleh Perusahaan Asuransi kepada Home Credit Indonesia.
        <br/><br/>
        Jika Tertanggung meninggal dunia akibat kecelakaan atau sakit, maka Santunan Biaya Pemakaman sebesar Jumlah yang Terhutang pada Home Credit Card dan/atau Home Credit BayarNanti akan dibayarkan ke Ahli Waris kamu.`}
      />
      <StepsComponent
        maxWidth="440px"
        marginWeb="64px 0"
        marginappright="48px 0 0 0"
        imgRight={RawatInap}
        title="Risiko Rawat Inap Selama minimum 3 hari karena sakit atau kecelakaan dalam Masa Asuransi"
        subtitle="Penggantian sebesar Total Tagihan terakhir pada Home Credit Card dan/atau Home Credit BayarNanti dengan maksimum penggantian bergantung pada jumlah hari rawat inap."
      />
      <HeadingComponent
        justifyMobile
        margin="8px"
        marginHeadingMobile="0px 16px 24px 16px"
        headingText="Cara klaim PROTEXI"
      />
      <Description
        alignMobile="left"
        font="Roboto"
        margin="0 16px"
        width="660px"
        text="Berikut adalah informasi cara klaim proteksi PROTEXI sesuai dengan Risiko serta daftar Pengecualian Manfaat."
      />
      <div className="pdf-links">
        <DownloadLink
          img={downloadIcon}
          linkName="Klik di sini untuk Prosedur Klaim Meninggal Dunia"
          url={`${process.env.baseUrl}/static/pdf/Prosedur-Klaim-Meninggal-Dunia_PROTEXI.pdf`}
        />
        <DownloadLink
          img={downloadIcon}
          linkName="Klik di sini Untuk Prosedur Klaim Cacat Tetap Total"
          url={`${process.env.baseUrl}/static/pdf/Prosedur-Klaim-Cacat-Tetap-Total_PROTEXI.pdf`}
        />
        <DownloadLink
          img={downloadIcon}
          linkName="Klik di sini Untuk Prosedur Klaim Rawat Inap"
          url={`${process.env.baseUrl}/static/pdf/Prosedur-Klaim-Rawat-Inap_PROTEXI.pdf`}
        />
        <DownloadLink
          img={downloadIcon}
          linkName="Klik di sini Untuk Pengecualian Manfaat"
          url={`${process.env.baseUrl}/static/pdf/Daftar-Pengecualian-PROTEXI.pdf`}
        />
      </div>
      <HeadingComponent
        fontWeight="bold"
        headingText="Penyedia Proteksi PROTEXI"
      />
      <Description
        font="Roboto"
        margin="16px 16px 64px 16px"
        width="620px"
        maxWidthMobile="260px"
        text="PROTEXI merupakan Produk Proteksi kolaborasi antara PT Home Credit Indonesia dengan<br/>PT Equity Life Indonesia yang berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK)."
      />
      <SEOText title={ProtexiSEO.title} text={ProtexiSEO.text} />
      <style jsx>{`
        .pdf-links {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      `}</style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = protexiMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      title,
      description,
      path,
      ProtexiBreadcrumb,
      ProtexiSEO
    }
  };
};

export default Protexi;
